import { Avatar, Button, Tooltip } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { MetaConversation } from 'lib-shared-legacy-types';
import { User } from 'lib-shared-types-api';
import { Component } from 'react';

import { numberFormatterInternational } from '../../../../../app/utils/telephonyHelpers';

import styles from './index.module.scss';

type UserItemProps = {
  user: any;
  metaConversation: MetaConversation;
  disabled?: boolean;
  highlighted?: boolean;
  profile: User;

  onAddCallerClick: (user: User) => void;
};

export default class UserItem extends Component<UserItemProps> {
  constructor(props: UserItemProps) {
    super(props);

    this.resolveAddActionTooltip = this.resolveAddActionTooltip.bind(this);
    this.resolveName = this.resolveName.bind(this);
    this.isUserProfile = this.isUserProfile.bind(this);
    this.isUserAuthor = this.isUserAuthor.bind(this);
    this.areActionsDisabled = this.areActionsDisabled.bind(this);

    this.renderAvatar = this.renderAvatar.bind(this);
    this.renderDetails = this.renderDetails.bind(this);
    this.renderAddAction = this.renderAddAction.bind(this);
  }

  isUserAuthor() {
    const {
      user,
      metaConversation: { conversation },
    } = this.props;

    return (
      conversation.authors &&
      Object.prototype.hasOwnProperty.call(conversation.authors, user.id)
    );
  }

  isUserProfile() {
    const { user, profile } = this.props;

    return user.id === profile.id;
  }

  areActionsDisabled() {
    return this.isUserAuthor() || this.isUserProfile();
  }

  resolveAddActionTooltip() {
    if (this.isUserAuthor()) {
      return 'This user is already in the conversation.';
    }
    if (this.isUserProfile()) {
      return 'You cannot add yourself.';
    }

    return 'Add caller to conversation.';
  }

  renderAvatar() {
    const { user } = this.props;

    const avatar =
      user.icon !== undefined ? (
        <Avatar icon={user.icon} />
      ) : (
        <Avatar user={user} />
      );

    return <div className={styles.avatar}>{avatar}</div>;
  }

  isNameAvailable() {
    const { user } = this.props;

    return (
      typeof user.name !== 'string' && typeof user.display_name !== 'string'
    );
  }

  resolveName() {
    const { user } = this.props;

    const nameField = ['name', 'display_name', 'phone_number', 'email'].find(
      (attribute: string) =>
        typeof user[attribute] === 'string' && user[attribute].length > 0,
    );

    return nameField ? user[nameField] : 'Anonymous';
  }

  renderDetails() {
    const { user, disabled } = this.props;

    const name = this.resolveName();
    const isNumberShown = this.isNameAvailable();
    const toPhoneNumberFormat = !disabled
      ? numberFormatterInternational({ phoneNumber: user.phone_number })
      : '';

    return (
      <div className={styles.details}>
        <span className={styles.name}>{name}</span>
        <span className={styles.extra}>
          {isNumberShown === false && user.phone_number !== null
            ? toPhoneNumberFormat
            : 'Contact'}
        </span>
      </div>
    );
  }

  renderAddAction() {
    const { user, onAddCallerClick } = this.props;

    const tooltip = this.resolveAddActionTooltip();

    return (
      <div className={styles.addToCallButton}>
        <Tooltip content={tooltip} wrap="span">
          <Button
            disabled={this.areActionsDisabled()}
            onClick={() => onAddCallerClick(user)}
            variant="secondary"
          >
            Add
          </Button>
        </Tooltip>
      </div>
    );
  }

  render() {
    const rootClass = classnames({
      [styles.root]: true,
      [styles.rootDisabled]: this.props.disabled,
    });

    return (
      <div className={rootClass}>
        {this.renderAvatar()}
        {this.renderDetails()}
        {this.renderAddAction()}
      </div>
    );
  }
}
